var seloElement = document.querySelectorAll(".selo-ra");

if(seloElement) {
    seloElement.forEach(element => {
        if (!element.querySelector('#reputation-ra')) {
            var div = document.createElement('div');
            div.id = "reputation-ra";
    
            var script = document.createElement('script');
            script.type = "text/javascript";
            script.id = "ra-embed-reputation";
            script.src = "https://s3.amazonaws.com/raichu-beta/selos/bundle.js";
            script.dataset.id = "ZGtCaTNId29GS2gtNE5KVDphbWVyaWNhLWNoaXA=";
            script.dataset.target = "reputation-ra";
            script.dataset.model = "2";
    
            var widgetDiv = document.createElement('div');
            widgetDiv.id = "ra-widget-reputation-fix";
            widgetDiv.innerHTML = '<div id="ra-widget-reputation" style="width:137px;height:48px;overflow:hidden;"><a class="ra-widget-reputation-holder" target="_blank" title="Selo Reclame Aqui" href="https://www.reclameaqui.com.br/empresa/america-chip/?utm_source=referral&utm_medium=embbed&utm_campaign=reputacao&utm_term=horizontal"><div style="visibility: hidden;" class="ra-widget-ra-1000 ra-widget-reputation-content type-2 ra-reputation-loaded"><img importance="high" style="height:auto;width:38px;" class="ra-widget-reputation-stamp" src="https://s3.amazonaws.com/raichu-beta/selos/assets/images/ra-1000.svg" alt="RA 1000" title="RA 1000"><div class="ra-widget-reputation-text">RA 1000</div><img importance="high" style="height:12.75px;width:80px;" class="ra-widget-reputation-logo" alt="Selo Reclame Aqui" src="https://s3.amazonaws.com/raichu-beta/selos/assets/images/reclame-aqui-logo.svg"></div></a></div>';
    
            div.appendChild(script);
            div.appendChild(widgetDiv);
            element.appendChild(div);
        }
    });
}

